import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchStockTakeProductSearch = createAsyncThunk(
  "fetchStockTakeProductSearch",
  async ({ keyword }) => {
    const token = localStorage.getItem("auth_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(
      `stock-take/search/products?keyword=${keyword}&limit=20`,
      config
    );

    return response.data.data;
  }
);

const stockTakeProductSearchSlice = createSlice({
  name: "stockTakeProductSearch",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchStockTakeProductSearch.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchStockTakeProductSearch.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.page;
      state.total = action.payload.total;
    });
    builder.addCase(fetchStockTakeProductSearch.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default stockTakeProductSearchSlice.reducer;
